export default __webpack_public_path__ + "static/media/uv5_kr_star_b1.cad403e5.mp3";